import React from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";

const LandingPage = () => {
  return (
    <div style={{marginTop: "2rem"}}>
      <Grid container justifyContent="center">
        <Grid item xs={12} sm={10} md={8} lg={6}>
          <Paper elevation={3} style={{ padding: "20px" }}>
            <Typography variant="h4" gutterBottom>
              License Manager Application
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              This app is divided into 3 parts:
            </Typography>
            <ul>
              <li>CloudCatcher Application Management</li>
              <li>Global License Management</li>
              <li>License Manager Application User Management</li>
            </ul>
            <Typography variant="body1">
              The menu icon on the App Bar will help you to route to those specific components.
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

export default LandingPage;
